module.exports = __webpack_public_path__ + "img/software.33e9d8df.jpg";